module.exports = __webpack_public_path__ + "media/images/flags/no-6df96bb22557028a5f7728dd629bfdef.svg";